import React, { memo, useCallback, useEffect } from 'react';
import './SearchSingleForm.css'
import { Col, Row } from "antd";
import MainData from './SearchResult/MainData';
import Toolbar from './SearchResult/Toolbar';
import SearchInformation from './SearchResult/SearchInformation';
import FormSearch from './Form/FormSearch';
import { SearchSingleFormModel, SearchSingleFunction } from '../../../../model/searchInvoiceModels';
import useQuery from '../../../../helper/queryString';
const SearchSingleForm: React.FC<{ header: string, searchInvoice: SearchSingleFunction }> = (props) => {
    const query = useQuery();
    let formValuesInit: SearchSingleFormModel = {
        taxCode: query.get("masothue") ?? "",
        securityCode: query.get("sobaomat") ?? ""
    }
    const [formValues, setFormValues] = React.useState<SearchSingleFormModel>(formValuesInit);
    const searchClickCallBack = useCallback((formValues: SearchSingleFormModel) => {
        formValues.taxCode = formValues.taxCode.trim();
        formValues.securityCode = formValues.securityCode.trim();
        query.set("masothue", formValues.taxCode);
        query.set("sobaomat", formValues.securityCode);
        var refresh = `${window.location.protocol}//${window.location.host}${window.location.pathname}?masothue=${encodeURIComponent(formValues.taxCode)}&sobaomat=${encodeURIComponent(formValues.securityCode)}`;
        window.history.pushState({ path: refresh }, '', refresh);
        setFormValues(formValues);
    }, [])
    return (
        <Row className="search-single-invoice-form-main">
            <Col xs={0} sm={0} md={formValues.taxCode && formValues.securityCode ? 0 : 8} />
            <Col xs={24} sm={24} md={formValues.taxCode && formValues.securityCode ? 12 : 8} className="search-single-invoice-form">
                <h1>Tra cứu {props.header}</h1>

                <FormSearch searchClickCallBack={searchClickCallBack} />
                {
                    formValues.taxCode && formValues.securityCode ?
                        <SearchInformation header={props.header} formValues={formValues} />
                        : <></>
                }

            </Col>
            {
                formValues.taxCode && formValues.securityCode ?
                    <Col xs={24} sm={24} md={11}>
                        <Toolbar searchFunction={props.searchInvoice} taxCode={formValues.taxCode} securityCode={formValues?.securityCode} />
                        <MainData searchFunction={props.searchInvoice} formValues={formValues} />
                    </Col>
                    : <></>
            }


        </Row >
    )
}
export default memo(SearchSingleForm)